var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizMesData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.35 2.13281H9.1V2.84375H10.5625H12.1875V6.90625V10.5625H6.09375H0.8125V6.90625V2.84375H4.55V4.875L7.3125 2.4375L4.55 0V2.13281H0.65C0.477609 2.13281 0.312279 2.20771 0.190381 2.34104C0.0684819 2.47437 0 2.6552 0 2.84375V10.6641C0 10.8526 0.0684819 11.0334 0.190381 11.1668C0.312279 11.3001 0.477609 11.375 0.65 11.375H12.35C12.5224 11.375 12.6877 11.3001 12.8096 11.1668C12.9315 11.0334 13 10.8526 13 10.6641V2.84375C13 2.6552 12.9315 2.47437 12.8096 2.34104C12.6877 2.20771 12.5224 2.13281 12.35 2.13281Z",
    fill: "#363432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizMesData);
export default __webpack_public_path__ + "static/media/quiz_mes_data.a56c66792513c8c2500e9bef52a574fd.svg";
export { ForwardRef as ReactComponent };